export const rows = [
  {
    antes: 'Dedicas demasiado tiempo a elegir ejercicios para la próxima clase.',
    con: 'Consultas un repertorio organizado por modalidad y objetivo.'
  },
  {
    antes: 'Repites las mismas secuencias porque no tienes tiempo de preparar otras.',
    con: 'Encuentras alternativas para variar el trabajo de tus sesiones.'
  },
  {
    antes: 'Tienes alumnos con diferentes capacidades y no sabes qué modificación elegir.',
    con: 'Dispones de opciones para facilitar o progresar los ejercicios.'
  },
  {
    antes: 'Conoces el movimiento, pero a veces te cuesta explicar qué debe corregir el alumno.',
    con: 'Consultas errores frecuentes e indicaciones de corrección.'
  }
];
